import { tsValidateValue } from '@nu-art/ts-common';
import { PathwayStateTypes } from './types.js';
export const Validator_PathwayStateType = tsValidateValue([...PathwayStateTypes]);
//# sourceMappingURL=validator.js.map